import axios from "axios"
import { ResponseAllMenu, PostMenuResponse, TypeResponseListMenu, TypePostMenu, DataMenu, TypeMenuById } from "../types/role-types"

export const postMenu = (data) => {
    const endpoint = 'menus/v2/store'
    return axios.post<PostMenuResponse>(endpoint, data).then(res => res.data)
}


export const getAllMenu = (): Promise<ResponseAllMenu<DataMenu[]>> => {
    const endpoint = 'menus/v2/data'
    return axios.get<ResponseAllMenu<DataMenu[]>>(endpoint).then(res => res.data)
}

export const getListMenu = (): Promise<TypeResponseListMenu> => {
    const endpoint = 'menus/v2/list'
    return axios.get<TypeResponseListMenu>(endpoint).then(res => res.data)
}

export const getMenuByUuid = (uuid: string): Promise<ResponseAllMenu<TypeMenuById>> => {
    const endpoint = `menus/v2/get/${uuid}`
    return axios.get(endpoint).then(res => res.data)
}

export const deleteMenu = (uuid: string) => {
    const endpoint = `menus/v2/delete/${uuid}`
    return axios.delete<PostMenuResponse>(endpoint).then(res => res.data)
}